import { render, staticRenderFns } from "./AddressTemplate.vue?vue&type=template&id=1b6937dc&"
import script from "./AddressTemplate.vue?vue&type=script&lang=js&"
export * from "./AddressTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports